import script from "./RightContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RightContent.vue?vue&type=script&setup=true&lang=ts"

import "./RightContent.vue?vue&type=style&index=0&id=5c2ab821&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2ab821"]])

export default __exports__